import * as t from "io-ts";

import { DeliveryDatePredictionID } from "./nominals";
import { nullable } from "./utils";

export const DeliveryDatePreference = t.readonly(
    t.type({
        preferred_date: nullable(t.string),
    }),
);
export type IDeliveryDatePreference = t.TypeOf<typeof DeliveryDatePreference>;

const DeliveryDatePrediction = t.readonly(
    t.type({
        status_code: t.literal("success"),
        prediction_id: DeliveryDatePredictionID,
        date_aggressive: t.string,
        date_conservative: t.string,
        slots_aggressive: t.readonlyArray(t.string),
        slots_conservative: t.readonlyArray(t.string),
        postcode: t.string,
        created_datetime: t.string,
    }),
);
export type IDeliveryDatePrediction = t.TypeOf<typeof DeliveryDatePrediction>;

const DeliveryDateUnpredictable = t.readonly(
    t.type({
        status_code: t.union([
            t.literal("deliverydates-api-offline-error"),
            t.literal("unpredictable-location-error"),
        ]),
    }),
);

export const DeliveryDatePredictionResponse = t.union([
    DeliveryDatePrediction,
    DeliveryDateUnpredictable,
]);
export type IDeliveryDatePredictionResponse = t.TypeOf<
    typeof DeliveryDatePredictionResponse
>;

export type IPredictionResponseStatusCode =
    | IDeliveryDatePredictionResponse["status_code"]
    | "unknown";
